import { render } from "./Form.vue?vue&type=template&id=b3a6cc8a&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=b3a6cc8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3a6cc8a"

export default script